import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReplayIcon } from "../components/icons";
import Spinner from "react-bootstrap/Spinner";
import { reorderItems } from "../ducks/reorder";
import useGoTo from "../hooks/useGoTo";
import useToast from "../hooks/useToast";

// Enquanto o pedido ainda está em andamento, a home mostra o acompanhamento
// (StatusButton); o "pedir de novo" só aparece depois.
const HOURS_ORDER_IN_PROGRESS = 3;

/**
 * "Pedir de novo" na home: refaz o último pedido desta loja com um toque.
 * A pesquisa da Baymard aponta isso como a maior lacuna dos apps de delivery.
 * Os itens são conferidos contra o cardápio de agora (ducks/reorder.js).
 */
export default function ReorderCard() {
  const dispatch = useDispatch();
  const goTo = useGoTo();
  const { toastSuccess, toastError } = useToast();
  const [isLoading, setLoading] = React.useState(false);
  const shop = useSelector((state) => state.shop);
  const lastCache = useSelector((state) => state.checkout.lastCheckoutCache);

  if (
    !lastCache ||
    !lastCache.reorderItems ||
    !lastCache.reorderItems.length ||
    lastCache.shopId !== shop.id ||
    !shop.isAvailableToOrder ||
    shop.isSelfcheckout
  ) {
    return null;
  }

  const hours = (new Date() - new Date(lastCache.createdAt)) / 36e5;
  if (hours < HOURS_ORDER_IN_PROGRESS) {
    return null;
  }

  const summary = (lastCache.orderedProducts || [])
    .map((p) => p.name)
    .join(", ");

  const reorder = async () => {
    setLoading(true);
    try {
      const { added, skipped } = await dispatch(
        reorderItems(lastCache.reorderItems),
      );
      if (!added) {
        toastError("Os itens do último pedido não estão mais disponíveis.");
        return;
      }
      if (skipped) {
        toastSuccess(
          `${added} ${added === 1 ? "item voltou" : "itens voltaram"} para a sacola. Alguns não estão mais disponíveis.`,
        );
      } else {
        toastSuccess("Pedido adicionado à sacola!");
      }
      goTo("/checkout");
    } catch (err) {
      console.error(err);
      toastError("Não foi possível refazer o pedido.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="reorder-card" aria-labelledby="reorder-title">
      <div className="reorder-card__text">
        <h2 id="reorder-title" className="reorder-card__title">
          Pedir de novo
        </h2>
        <p className="reorder-card__summary">{summary}</p>
      </div>
      <button
        type="button"
        className="btn btn-outline-shop reorder-card__button"
        onClick={reorder}
        disabled={isLoading}
      >
        {isLoading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <>
            <ReplayIcon fontSize="small" className="me-1" />
            Repetir
          </>
        )}
      </button>
    </section>
  );
}
